/* src/app/components/incompatible-lamination-alert/incompatible-lamination-alert.component.scss */
ion-icon.close-icon {
  width: 26px;
  height: 26px;
}
ion-icon.alert-icon {
  width: 34px;
  height: 34px;
}
.alert-text {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
hr {
  height: 1px;
  background: #cbcbcb;
}
.text1 {
  color: #000;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.text2 {
  color: #949494;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.warning-box {
  color: #d59b00;
  font-weight: 500;
  border-radius: 20px;
  background-color: #fff0c6;
  padding: 8px 15px;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
/*# sourceMappingURL=incompatible-lamination-alert.component-DJII7UOZ.css.map */
